import { parsePrintedNumber } from "@/lib/catalog/collectorNumber";
import { withoutRepeatedCollectorNumber } from "@/lib/catalog/printingTreatment";

/** Card identity text shared by marketplace searches without provider-specific operators. */
export function marketplaceSearchQuery({ name, number, setName, game, printing }: {
  name: string;
  number?: string | null;
  setName?: string | null;
  game?: string | null;
  printing?: string | null;
}): string {
  const cardName = withoutRepeatedCollectorNumber(name, number).replace(/\bholofoil\b/gi, "Holo");
  const treatment = printing?.trim().replace(/\bholofoil\b/gi, "Holo");
  // Sold titles often omit the denominator: 9/111 misses listings titled #9 (TRO-2042).
  const collectorNumber = parsePrintedNumber(number)?.canonical.toUpperCase() ?? number?.trim();
  return [
    cardName,
    setName?.trim() || game?.trim(),
    collectorNumber,
    treatment && !/^(normal|standard|regular)$/i.test(treatment)
      && !cardName.toLowerCase().includes(treatment.toLowerCase())
      ? treatment
      : null,
  ].filter(Boolean).join(" ");
}
